<ng-template #drawerTemplate let-data let-drawerRef="drawerRef">
  value: {{ data?.value }}
  <br />
  <br />
  <button ui-button buttonType="primary" (click)="drawerRef.close()">close</button>
</ng-template>

<button ui-button buttonType="primary" (click)="openTemplate()">Open Drawer From Template</button>

<button ui-button buttonType="primary" (click)="openComponent()">Open Drawer From Component</button>
